import React, { useState } from "react";

type ComparisonTableProps = {
  data: {
    type: string;
    heading: string;
    subheading: string;
    competitorLogo: string;
    data: {
      feature: string;
      competitor: string;
      graphy: string;
    }[];
  };
};

const ComparisonTable: React.FC<ComparisonTableProps> = ({ data }) => {
  const [itemsToShow, setItemsToShow] = useState<number>(5);

  return (
    <div className="container mb-12">
      <div className="flex items-start justify-between self-stretch">
        <div className="container mb-12 flex flex-col gap-4 text-center">
          <h2 className="font-obviously w-full whitespace-pre-wrap text-center text-title-32 font-semibold text-slate01">
            {data?.heading}
          </h2>
          {data?.subheading && <p>{data?.subheading}</p>}
        </div>
      </div>
      <div className="flex w-full overflow-hidden border border-grey-2 rounded-xl md:border-purple-2">
        <div className="flex w-full flex-1 flex-col items-start  gap-6 bg-grey-1 p-3 md:p-5">
          <h3 className="text-title-16 sm:text-title-20 font-semibold">Benefits</h3>
          <div className="flex flex-col gap-6 h-full">
            {data?.data.map((item) => {
              return (
                <span className="width-max text-title-12 sm:text-title-14 flex-1" key={item.feature}>
                  {item?.feature}
                </span>
              );
            })}
          </div>
        </div>
        <div className="flex w-full flex-1 flex-col items-start gap-6 p-3 md:p-5">
          <img src={data.competitorLogo} alt="competitor logo" className="w-[133px] h-[23px]" />

          <div className="flex flex-col gap-6 h-full">
            {data?.data.map((item) => {
              return (
                <div key={item?.competitor} className="flex gap-3 items-center flex-1">
                  <img
                    src="/images/icons/cross-circle.svg"
                    alt="competitor feature"
                    width={20}
                  />

                  <span
                    className="widthax text-body-12 sm:text-body-14  text-grey-4"
                    key={item.feature}
                  >
                    {item?.competitor}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
        <div className="flex max-w-[355px] flex-1 flex-col items-start gap-6 bg-purple-0 p-3 md:p-5">
          <img src="/images/graphy-logo.svg" alt="Graphy logo" className="w-[80px] h-[22px]" />
          <div className="flex flex-col gap-6 h-full">
            {data?.data.map((item) => {
              return (
                <div key={item?.graphy} className="flex gap-3 flex-1">
                  <img
                    src="/images/icons/check-circle.svg"
                    alt="graphy feature"
                    width={20}
                  />
                  <span
                    className="width-max text-body-12 sm:text-body-14 text-grey-4"
                    key={item.feature}
                  >
                    {item?.graphy}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ComparisonTable;